import {useSelector} from 'react-redux';
import {RootState} from '../store/store';

export const useCanCloseDialog = () :boolean => useSelector((state:RootState) => state.settings.reachabilityPoints.length > 0
  && state.settings.selectedSatisfactionOption !== null
  && !state.ui.invalidRequestedData);
